module.exports = __webpack_public_path__ + "static/about-video-02dc3a79d27ccb96230b123c99bbc944.mp4";